import React, { ChangeEventHandler} from 'react';
import classNames from 'classnames';


export const Input = ({
  iconClass,
  iconLeft,
  label,
  id,
  className,
  type = 'text',
  attribute,
  placeholder,
  required = false,
  disabled = false,
  readOnly = false,
  autoFocus = false,
  minLength,
  maxLength,
  value,
  onChange = () => null,
  rounded = 'rounded-none',
  shadow = 'shadow-none',
  helpText,
  hasError,
  errorMessage,
}) => {
  const inputClass = classNames([
    className,
    rounded,
    shadow,
    ' w-full px-3 py-3 block border border-gray-300 text-base text-left placeholder-gray-400 appearance-none focus:outline-none focus:ring-brand-1 focus:border-brand-1',
    {
      'mt-1': label,
      'bg-gray-200 cursor-not-allowed': disabled,
      'bg-gray-200': readOnly,
      'border-red-600': hasError,
      'pr-10': iconClass && !iconLeft,
      'pl-10': iconClass && iconLeft,
    },
  ]);

  return (
    <div className="relative">
      {label && (
        <label
          className="block mb-1 text-sm text-left font-semibold text-gray-700"
          htmlFor={id ? id : attribute}
        >
          {label}
          {required && ' *'}
        </label>
      )}
      {iconClass && (
        <div
          className={classNames('absolute text-gray-400 -translate-y-1/2', {
            'top-[calc(50%+14px)]': label,
            'top-[calc(50%+2px)]': !label,
            'left-[15px]': iconLeft,
            'right-[15px]': !iconLeft,
          })}
        >
          <span className={`icon ${iconClass}`}></span>
        </div>
      )}
      <input
        id={id ? id : attribute}
        className={inputClass}
        type={type}
        name={attribute}
        value={value}
        placeholder={placeholder ?? label}
        minLength={minLength}
        maxLength={maxLength}
        disabled={disabled}
        readOnly={readOnly}
        autoFocus={autoFocus}
        required={required}
        onChange={onChange}
      />
      {hasError && errorMessage && (
        <div className="mt-2 text-xs text-red-600">{errorMessage}</div>
      )}
      {helpText && <div className="mt-2 text-xs text-gray-400">{helpText}</div>}
    </div>
  );
};
